import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CountryEntity } from './country.entity';
import { catchError, mergeMap, of, tap } from 'rxjs';
import { CountryActions } from './country.actions';

@Injectable()
export class CountryEffects {
  private readonly actions$ = inject(Actions);

  private readonly init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryActions.init),
      mergeMap(action => {
        const entities = action.countries.map<CountryEntity>(country => CountryEntity.fromJson(country));
        return of(CountryActions.loadSuccess({ entities }));
      }),
      catchError(error => of(CountryActions.loadFailure({ error })).pipe(tap(error => console.error(error)))),
    ),
  );
}
